var styles = {"tend-ui-form-help-root":"tend-ui-form-help-root"};

export { styles as default };
